const _team = {
	showCards: false,
	title: 'Equipo',
	subtitle: 'Somos personas enfocadas',
	description:
		'<p class="lead">Somos un equipo de profesionales que aportamos lo mejor de cada uno para proporcionar a nuestros clientes contenidos y formatos de calidad.</p><p class="lead">Dentro del equipo de Onfocus Media contamos con gente especializada en diferentes campos: camarógrafos, editores, sonidistas, fotógrafos, realizadores, diseñadores y creativos.</p><p class="lead mb-0">Somos un equipo con más de 15 años de experiencia que le gustaría unirse a tu proyecto.</p>',
	items: [
		{
			id: 1,
			isFirst: true,
			isLast: false,
			media_type: 'video',
			media: {
				file_mp4: 'sergio.mp4',
				file_webm: 'sergio.webm'
			},
			info: {
				name: 'Sergio Carmona',
				position: 'Cargo 1',
				intro: 'Intro text 1',
				description: 'Description text one. Longer than titles to test card layout.'
			},
			social: {
				email: 'sergio@email.com',
				facebook: 'http://google.com',
				instagram: 'http://google.com',
				twitter: 'http://google.com',
				linkedin: 'http://google.com'
			}
		},
		{
			id: 2,
			isFirst: false,
			isLast: false,
			media_type: 'image',
			media: {
				file: 'hugo1.jpg'
			},
			info: {
				name: 'Hugo Carmona',
				position: 'Cargo 2',
				intro: 'Intro text 2',
				description: 'Description text two. Longer than titles to test card layout.'
			},
			social: {
				email: 'hugo@email.com',
				facebook: '',
				instagram: '',
				twitter: 'http://google.com',
				linkedin: ''
			}
		},
		{
			id: 3,
			isFirst: false,
			isLast: false,
			media_type: 'image',
			media: {
				file: 'hugo2.jpg'
			},
			info: {
				name: 'Berni',
				position: 'Cargo 3',
				intro: 'Intro text 3',
				description: 'Description text three. Longer than titles to test card layout.'
			},
			social: {
				email: '',
				facebook: '',
				instagram: 'http://google.com',
				twitter: '',
				linkedin: ''
			}
		},
		{
			id: 4,
			isFirst: false,
			isLast: true,
			media_type: 'image',
			media: {
				file: 'hugo3.jpg'
			},
			info: {
				name: 'Fulanito Menganito',
				position: 'Cargo 4',
				intro: 'Intro text 4',
				description: 'Description text four. Longer than titles to test card layout.'
			},
			social: {
				email: '',
				facebook: '',
				instagram: '',
				twitter: '',
				linkedin: ''
			}
		}
	]
}

export default {
	getData(callback) {
		callback(_team)
	}
}
